<script>
    export let color = "currentColor";
    export let width = "100%";

</script>

<div style="width:{width};height:100%;max-width:100%;max-height:100%">
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 369"
        width="100%"
        height="100%"
        fill={color}
    >
        <defs>
            <style>
                .cls-1 {
                    fill-rule: evenodd;
                }

            </style>
        </defs>
        <path
            id="Color_Fill_1"
            data-name="Color Fill 1"
            class="cls-1"
            d="M110,4V16h-8c-5.1,13.707-23.787,53.8,8,56V84h16l-1,3c-15.622,15.243-57.592,87.313-51,118C44.78,210.462.122,231.461,5,266c6.014,6.746,11.171,10.786,24,11C0.114,371.357,135.137,395.392,147,310c20.815-.1,27.3,6.637,43,9l153,1c11.891,61.28,103.436,53.966,118-1h35c1.356-71.434-22.522-131.813-62-163,7.118-9.632,13.695-50.348,0-59-10.974-6.933-192.1,2.98-204,9-7.489,12.074-6.644,38.07,1,49l20,3c20.87,9.159,34.129,68.8,9,83-15.956,9.018-55.991,4.729-79,4-23.778-47.4-17.762-133.635,9-171l14,2c3.911-5.165,5.295-7.5,4-16C171.821,38.429,169.617,3.562,110,4Z"
        />
    </svg>
</div>
